<div class="header">
    <h2 mat-dialog-title>{{ 'locker.delete.title' | translate }}</h2>
    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
</div>
<mat-dialog-content>
    <span>{{ 'locker.delete.confirmation' | translate }}</span>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button class="btn-white" type="button" (click)="close()">{{ 'locker.delete.cancel' | translate }}</button>
    <button mat-flat-button color="primary" (click)="delete()">{{ 'locker.delete.confirm' | translate }}</button>
</mat-dialog-actions>